import styled from 'styled-components';
import { breakpoints } from '@/layouts/breakpoints';

const StyledJobs = styled.div`
  overflow-x: hidden;

  /* ── Hero ─────────────────────────────────────────────── */
  .fold {
    width: 100vw;
    min-height: 360px;
    padding: 80px 40px;
    border-bottom: 1px solid rgba(var(--greyr), 0.3);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100vw;
    @media (max-width: ${breakpoints.medium}) {
      // overflow: hidden;
      position: relative;
    }
    video{
      width: 140vw;
      min-height: 100vh;
      height: auto;
      position: absolute;
      object-fit: contain;
      top: -20vh;
      left: 0;
      opacity: 0.4;
      z-index: -1;
      max-width: 1800px;
      @media (max-width: ${breakpoints.large}) {
        height: 100vh;
        left: -25%;
      }
      @media (max-width: ${breakpoints.medium}) {
        width: auto;
        min-width: 100vw;
        min-height: 360px;
        height: 150%;
        top: 0vh;
        left: -25%;
      }
    }

    .text {
      text-align: center;
      color: var(--black);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;

      h1 {
        font-size: 56px;
        padding: 0;
        line-height: 1.1;
        letter-spacing: -0.5px;
      }

      span {
        color: var(--grey);
        max-width: 480px;
        font-weight: 100;
        line-height: 1.6;
        font-size: 20px;
        display: block;
      }
    }
  }

  /* ── Jobs Container ───────────────────────────────────── */
  .jobs-container {
    max-width: 1100px;
    margin: 0 auto;
    padding: 56px 40px 80px;
margin-bottom: 40px;
  }

  /* ── Filter Bar ───────────────────────────────────────── */
  .filter-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding-bottom: 32px;
    border-bottom: 1px solid rgba(var(--greyr), 0.3);
    margin-bottom: 48px;

    input {
      flex: 1;
      max-width: 420px;
      padding: 12px 16px;
      border: 1px solid rgba(var(--greyr), 0.3);
      border-radius: 6px;
      font-size: 14px;
      color: var(--black);
      transition: border-color 0.2s;
      outline: none;

      &::placeholder {
        color: var(--grey);
      }

      &:focus {
        border-color: rgba(var(--greyr), 0.7);
      }
    }

  .filter-options {
    display: flex;
    gap: 12px;

    select {
      appearance: none;
      -webkit-appearance: none;
      padding: 12px 40px 12px 16px;
      border: 1px solid rgba(var(--greyr), 0.3);
      border-radius: 6px;
      font-size: 14px;
      color: var(--black);
      background-color: var(--white);
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 14px center;
      cursor: pointer;
      outline: none;
      transition: border-color 0.2s;

      &:focus {
        border-color: rgba(var(--greyr), 0.7);
      }
    }
  }
  }

  /* ── Results count ────────────────────────────────────── */
  .results-count {
    font-size: 12px;
    color: var(--grey);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 20px;
  }

  /* ── Job Listings ─────────────────────────────────────── */
  .job-listings {
    display: flex;
    flex-direction: column;
    gap: 0;
    border: 1px solid rgba(var(--greyr), 0.3);
    border-radius: 10px;
    overflow: hidden;

    .job {
      display: grid;
      grid-template-columns: 1fr auto;
      align-items: center;
      gap: 40px;
      padding: 32px 36px;
      border-bottom: 1px solid rgba(var(--greyr), 0.3);
      transition: background 0.15s ease;
      background: var(--white);

      &:last-child {
        border-bottom: none;
      }


      .job-info {
        display: flex;
        flex-direction: column;
        gap: 10px;

        h2 {
          font-size: 20px;
          color: var(--black);
          margin: 0;
          line-height: 1.2;
        }

        .job-meta {
          display: flex;
          gap: 24px;
          margin: 0;

          div {
            display: flex;
            align-items: center;
            gap: 6px;
            color: #6d6d6d;

            span {
              font-size: 12px;
              letter-spacing: 0.04em;
              text-transform: capitalize;
            }
          }
        }

        p.description {
          color: var(--black);
          line-height: 1.65;
          font-size: 14px;
          max-width: 600px;
          opacity: 0.7;
          margin: 0;
        }
      }

      .job-action {
        flex-shrink: 0;

        button {
          padding: 12px 28px;
          border: 1px solid var(--black);
          border-radius: 6px;
          background-color: var(--black);
          color: var(--white);
          cursor: pointer;
          font-size: 14px;
          white-space: nowrap;
          transition: opacity 0.15s ease;

          &:hover {
            opacity: 0.75;
          }
        }
      }
    }

    /* ── Empty State ────────────────────────────────────── */
    .empty-state {
      text-align: center;
      padding: 80px 40px;
      background: var(--white);

      h2 {
        font-size: 20px;
        color: var(--black);
        margin-bottom: 10px;
      }

      p {
        color: var(--grey);
        font-size: 14px;
      }
    }
  }

  /* ── Large (≤1024px) ──────────────────────────────────── */
  @media (max-width: ${breakpoints.large}) {
    .fold {
      padding: 60px 30px;
      min-height: 300px;
    }

    .jobs-container {
      padding: 40px 30px 60px;
    }
  }

  /* ── Medium (≤768px) ──────────────────────────────────── */
  @media (max-width: ${breakpoints.medium}) {
    .fold {
      padding: 50px 24px;
      min-height: 260px;

      .text h1 {
        font-size: 42px;
      }
    }

    .jobs-container {
      padding: 32px 24px 60px;
    }

    .filter-bar {
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
      padding-bottom: 24px;
      margin-bottom: 36px;

      input {
        max-width: none;
      }
    }

    .job-listings .job {
      grid-template-columns: 1fr;
      gap: 20px;
      padding: 24px;

      .job-action button {
        width: 100%;
      }

      .job-meta {
        flex-wrap: wrap;
        gap: 12px;
      }
    }
  }

  /* ── Small (≤550px) ───────────────────────────────────── */
  @media (max-width: ${breakpoints.small}) {
    .fold {
      padding: 40px 20px;
      min-height: 220px;

      .text h1 {
        font-size: 36px;
      }

      .text span {
        font-size: 16px;
      }
    }

    .jobs-container {
      padding: 24px 16px 48px;
    }

    .job-listings .job {
      padding: 20px 16px;

      .job-info h2 {
        font-size: 18px;
      }

      .job-info p.description {
        font-size: 13px;
      }
    }

    .empty-state {
      padding: 60px 24px;
    }
  }

  /* ── XSmall (≤400px) ──────────────────────────────────── */
  @media (max-width: ${breakpoints.xsmall}) {
    .fold {
      padding: 32px 16px;
      min-height: 200px;

      .text h1 {
        font-size: 28px;
      }

      .text span {
        font-size: 14px;
      }
    }

    .filter-bar {
      select {
        width: 100%;
      }
    }

    .job-listings .job {
      padding: 16px 12px;

      .job-info h2 {
        font-size: 16px;
      }

      .job-meta {
        flex-direction: column;
        gap: 8px;
      }
    }

    .empty-state {
      padding: 40px 16px;
    }
  }
`;

export default StyledJobs;
